import styled from "styled-components";

export const QuizProfileWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem 0;
  box-sizing: border-box;
  font-family: "Poppins", sans-serif;
  color: #222;
`;

export const QuizTabs = styled.div`
  display: flex;
  border-bottom: 1px solid #ddd;
  margin-bottom: 1rem;
  gap: 2rem;
  overflow-x: ${({ $scrollable }) => ($scrollable ? "auto" : "visible")};
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 768px) {
    gap: 1rem;
    padding-bottom: 4px;
  }
`;

export const QuizTabButton = styled.button`
  background: none;
  border: none;
  font-size: 1.125rem;
  padding: 0.5rem 0;
  cursor: pointer;
  color: ${({ $active }) => ($active ? "#000" : "#666")};
  font-weight: ${({ $active }) => ($active ? "600" : "400")};
  position: relative;
  flex: 0 0 auto;
  white-space: nowrap;

  &::after {
    content: "";
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 2px;
    background: ${({ $active }) => ($active ? "#000" : "transparent")};
  }
`;

export const QuizSectionTitle = styled.h4`
  margin: 18px 0 8px;
  font-size: 1.075rem;
  color: #333;
`;

export const QuizErrorMessage = styled.div`
  padding: 16px;
  margin: 20px 0;
  background-color: #fee;
  border: 1px solid #fcc;
  border-radius: 8px;
  color: #c33;
  text-align: center;
`;

export const QuizEmptyMessage = styled.div`
  padding: 24px 16px;
  text-align: center;
  color: #888;
  font-size: 16px;
`;

export const QuizTopicCard = styled.div`
  border: 1px solid #e5e5e5;
  border-radius: 16px;
  padding: 16px;
  background: #fff;
`;

export const QuizTopicHeader = styled.div`
  display: grid;
  gap: 4px;
  margin-bottom: 12px;

  strong {
    font-size: 1.125rem;
    color: #111;
  }

  p {
    margin: 0;
    font-size: 1.005rem;
    color: #666;
  }
`;

export const QuizSummaryGrid = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  margin: 10px 0 16px;
`;

export const QuizSummaryCard = styled.div`
  border: 1px solid #e5e5e5;
  border-radius: 12px;
  padding: 10px 12px;
  background: #fff;

  strong {
    display: block;
    font-size: 0.875rem;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }

  span {
    display: block;
    font-size: 1.225rem;
    color: #222;
    margin-top: 4px;
  }
`;

export const QuizInlineInfo = styled.div`
  padding: 10px 12px;
  border-radius: 10px;
  background: #fafafa;
  color: #666;
  font-size: 1.005rem;
`;

export const QuizBadge = styled.span`
  background: #f3f4f6;
  color: #444;
  border: 1px solid #ddd;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
`;

export const QuizPrimaryButton = styled.button`
  background: #111;
  color: #fff;
  border: none;
  border-radius: 999px;
  padding: 10px 18px;
  font-size: 15px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const QuizListActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const QuizCardSkeletonGroup = styled.div`
  display: grid;
  gap: 12px;
`;
